export const BASE_URL =  "https://api.inventoryerp.in/api/v1/";
export const STATIC_BASE_URL = "https://api.inventoryerp.in/";

export const REGISTER = "auth/register";
export const LOGIN = "auth/login";
export const LOGOUT = "auth/logout";
export const LOGIN_SEND_OTP = "auth/loginsend-otp";
export const VERIFY_OTP = "auth/verify-otp";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const RESET_PASSWORD = "auth/reset-password";
export const MACHINE_CREATION = "admin/machine/create-machine";
export const RAWMATERIAL_MACHINE_MAPPING = "admin/rawmaterialmapping/create";
export const GET_RAW_MATERIALS_BY_MACHINE = "admin/rawmaterialmapping";
export const EDIT_RAW_MATERIALS_BY_MACHINE = "admin/rawmaterialmapping/edit";
export const GET_RAW_MATERIALS = "admin/raw-material";
export const CREATE_RAW_MATERIAL = "admin/create-raw-material";
export const CREATE_ADMIN = "super-admin/create-admin";
export const GET_ALL_ADMINS = "super-admin/admins";
export const GET_ADMIN = "super-admin/admin/:id";
export const UPDATE_ADMIN = "super-admin/admin";
export const DELETE_ADMIN = "super-admin/admin";
export const GET_ALL_MACHINES = "admin/machine";
export const GET_MACHINE = "admin/machine";
export const EDIT_RAW_MATERIAL = "admin/edit-raw-material";
export const DELETE_RAW_MATERIAL = "admin/delete-raw-material";
export const CREATE_USER = "admin/user/create";
export const GET_USER = "admin/user";
export const EDIT_USER = "admin/user/edit";
export const DELETE_USER = "admin/user/delete";
export const ADMIN_DASHBOARD = "admin/dashboard";
export const PROFILE = "users/profile";
export const CREATE_ORDER ="admin/order/create";
export const GET_ORDER = "admin/order";
export const PR_GET_ORDER = "pr-manager/order/all";
export const PR_UPDATE_ORDER = "pr-manager/order"
export const PR_DASHBOARD = "pr-manager/dashboard";
export const DELETE_RAW_MATERIALS_BY_MACHINE = "admin/rawmaterialmapping/delete";
export const PRODUCTION_TRACKING = "admin/status/order-status";
export const STORE_MANAGER_GET_STOCK = "stock-manager/raw-material";
export const STORE_MANAGER_EDIT_STOCK = "stock-manager/edit-raw-material";
export const CREATE_REPORT = "stock-manager/damageReport/create";
export const GET_REPORT = "stock-manager/damageReport/get";
export const EDIT_REPORT = "stock-manager/damageReport/update";
export const GET_ADMIN_REPORT = "admin/damageManagement";
export const EDIT_ADMIN_REPORT = "admin/damageManagement";
export const UPDATE_SUBSCRIPTION = "super-admin/update-client-subscription";
export const SUPER_ADMIN_DASHBOARD = "super-admin/dashboard";
export const RE_CALCULATE = "admin/raw-material/recalculate";
export const RAWMATERIAL_HISTORY = "admin/raw-material/history/:id";

